var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScrollUp = function SvgScrollUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_1",
    "data-name": "Component 74 \\u2013 1",
    width: 19.008,
    height: 21.843,
    viewBox: "0 0 19.008 21.843",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M1.188,1.5A1.176,1.176,0,0,0,0,2.67V3.84A1.176,1.176,0,0,0,1.188,5.01H17.82a1.176,1.176,0,0,0,1.188-1.17V2.67A1.176,1.176,0,0,0,17.82,1.5ZM4.475,15.176l3.247-3.2V22.173a1.176,1.176,0,0,0,1.188,1.17H10.1a1.176,1.176,0,0,0,1.188-1.17V11.978l3.247,3.2a1.2,1.2,0,0,0,1.678,0l.842-.829a1.153,1.153,0,0,0,0-1.653L10.346,6.088a1.2,1.2,0,0,0-1.678,0L1.955,12.694a1.153,1.153,0,0,0,0,1.653l.842.829A1.2,1.2,0,0,0,4.475,15.176Z",
    transform: "translate(0 -1.5)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll-up.ec88e260.svg";
export { ForwardRef as ReactComponent };